import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { usePageTitle } from 'app/utils/web-helpers';
import { canUseInterests } from 'app/utils/helpers';
import * as React from 'react';
import { View } from 'react-native';
import { QuickInterestsScreenContent, useQuickInterestsScreen } from './quick-interests-screen-body';

const QuickInterestsScreenInner: NavigationScreen<'quickInterests'> = (props) => {
  const setPageTitle = usePageTitle('interests');
  React.useEffect(() => setPageTitle('title'), [setPageTitle]);

  const { navigation } = props;
  React.useEffect(() => {
    if (!canUseInterests()) navigation.reset({ routes: [{ name: 'main' }] });
  }, [navigation]);

  return canUseInterests() ? <QuickInterestsContent {...props} /> : null;
};

const QuickInterestsContent: NavigationScreen<'quickInterests'> = (props) => {
  const state = useQuickInterestsScreen(props);

  return (
    <View style={{ flex: 1 }}>
      <QuickInterestsScreenContent state={state} />
    </View>
  );
};

export const QuickInterestsScreen: NavigationScreen<'quickInterests'> = withOptionalMetrics(
  'QuickInterestsScreen',
  withErrorBoundary(QuickInterestsScreenInner),
);
